<template>
  <div class="sl">
    <div class="fb-login-button mr-2"
         data-max-rows="1"
         data-size="large"
         data-button-type="login_with"
         data-show-faces="false"
         data-auto-logout-link="false"
         data-scope="public_profile,email"
         data-use-continue-as="true">
    </div>
    <div id="btnGoogleSignIn" class="ml-2"></div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/custom.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

.social-login {
  flex-direction: column;
  align-items: center;
  .fb-login-button {
    margin-bottom: 1em;
  }
}
@include media-breakpoint-up(lg) {
  .social-login {
    flex-direction: row;
    .fb-login-button {
      margin-bottom: 0;
    }
  }
}
.sl {
  display: flex;
  justify-content: space-around;
}

.spacer {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SocialLogin',
  computed: {
    ...mapGetters('social', ['fbInitialized', 'googleInitialized', 'googleAuth2'])
  },
  mounted () {
    if (this.fbInitialized && this.googleInitialized) this.initComponent()
  },
  watch: {
    'googleInitialized': 'initComponent',
    'fbInitialized': 'initComponent'
  },
  methods: {
    initComponent () {
      if (!this.googleInitialized || !this.fbInitialized) return

      window.gapi.signin2.render('btnGoogleSignIn', {
        scope: 'profile email',
        width: 200,
        height: 40,
        longtitle: true,
        theme: 'dark',
        onsuccess: googleUser => { this.handleGoogleUser(googleUser) },
        onfailure: () => { console.log('[social-login:google] error logging in', arguments) }
      })

      window.FB.Event.subscribe('auth.authResponseChange', response => { this.handleFbAuth(response) })
      window.FB.XFBML.parse()

      window.FB.getLoginStatus(response => {
        if (response && response.status === 'connected') this.handleFbAuth(response)
      })
    },
    async handleGoogleUser (googleUser) {
      const authResponse = googleUser.getAuthResponse()
      try {
        await this.$store.dispatch('auth/socialAuth', { provider: 'google', token: authResponse.id_token })
      } catch (e) {
        let msg = 'Unable to log in'
        if (e.response && e.response.data && e.response.data.message) msg = e.response.data.message
        this.$store.dispatch('flash/showMessage', { message: msg, type: 'error' })
        this.$store.dispatch('social/logout')
      }
    },
    async handleFbAuth (response) {
      if (response.status === 'connected') {
        try {
          this.$store.dispatch('auth/socialAuth', { provider: 'facebook', token: response.authResponse.accessToken })
        } catch (e) {
          let msg = 'Unable to log in'
          if (e.response && e.response.data && e.response.data.message) msg = e.response.data.message
          this.$store.dispatch('flash/showMessage', { message: msg, type: 'error' })
          this.$store.dispatch('social/logout')
        }
      } else {
        console.log('[social-login:facebok] error logging in', response)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/SocialLogin.vue